// extracted by mini-css-extract-plugin
export var fileUpload = "_ff-1";
export var modalButton = "_ff-0";